import { Box, Skeleton } from "@mui/material";
import { BAR_GRAPH_DIRECTION } from "../graphs/BarChart";
import { FC } from "react";
import { globalStyles } from "../../styles/GlobalStyles";

interface BarGraphLoaderProps {
  direction?: BAR_GRAPH_DIRECTION;
  numberOfBars?: number;
}

const BarGraphLoader: FC<BarGraphLoaderProps> = ({
  direction,
  numberOfBars = 3,
}) => {
  const isHorizontal = direction === BAR_GRAPH_DIRECTION.HORIZONTAL;

  return (
    <Box sx={globalStyles.col} height="100%">
      {isHorizontal ? (
        <>
          <Skeleton variant="text" sx={{ fontSize: "2rem", mx: 15, mb: 2 }} />
          <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
          <Skeleton variant="text" sx={{ fontSize: "1rem", my: 1 }} />
          <Skeleton variant="text" sx={{ fontSize: "1rem", mb: 3 }} />

          <Box sx={globalStyles.col} flex={1} gap={1.5}>
            {Array.from({ length: numberOfBars }, (itm: number) => {
              const randomWidth = Math.floor(Math.random() * (100 - 50) + 50);

              return (
                <Skeleton
                  key={itm}
                  variant="rectangular"
                  sx={{ flex: 1, width: `${randomWidth}%` }}
                />
              );
            })}
          </Box>
        </>
      ) : (
        <>
          <Skeleton variant="text" sx={{ fontSize: "2rem", mr: 25, mb: 2 }} />

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-end"
            mx={12}
            flex={1}
          >
            {Array.from({ length: numberOfBars }, (itm: number) => {
              const randomHeight = Math.floor(Math.random() * (95 - 50) + 50);

              return (
                <Skeleton
                  key={itm}
                  variant="rectangular"
                  sx={{ width: "20%", height: `${randomHeight}%` }}
                />
              );
            })}
          </Box>

          <Skeleton variant="text" sx={{ fontSize: "1rem", mt: 3 }} />
        </>
      )}
    </Box>
  );
};

export default BarGraphLoader;
